module.exports = __webpack_public_path__ + "static/social-media-image-a3497b7daf3b17ef8df04d79c32f188b.jpg";